import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImvideoComponent } from './components/imvideo/imvideo.component';
import { LoaderComponent } from './loader/loader.component';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import {FormsModule} from '@angular/forms';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HttpClientModule } from '@angular/common/http';
// import { IAmVideoRoutingModule } from './i-am-video-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';



@NgModule({
  declarations: [
    ImvideoComponent,
    LoaderComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
   HttpClientModule,
    FormsModule,
    ImageCropperModule,
    MatButtonModule,
     MatProgressBarModule
  ]
})
export class IAmVideoModule { }
